<template>
  <!-- 
    name: 覃刚
    function: 登录页面
    date: 2021-03-01 
 -->
 <div class="loginPageClass">
  <div class="loginBox">
    <div class="login-slider">
      <div class="login-slider-inner">
        <a-carousel dot-position="bottom" :autoplay="true">
          <div v-for="(item,index) in banner" :key="index">
            <div class="banner-img" :style='{backgroundImage:`url(${item.img})`}' />
            <div class="banner-title">{{ item.title }}</div>
          </div>
        </a-carousel>
      </div>
    </div>
    <div class="login-container">
        <img src="../../assets/images/logo_nhf.svg" alt="NHF PRO" class="imgClass" />
      <a-form  id="components-form-demo-normal-login" :form="form" class="login-form" >
        <a-form-item>
          <a-input size="large" @pressEnter="loginIn" v-decorator="[ 'account', { rules: [{ required: true, message: '账户不能为空' }] }, ]" placeholder="账户" >
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input-password size="large" v-decorator="[ 'password', { rules: [{ required: true, message: '密码不能为空' }] }, ]" @pressEnter="loginIn" placeholder="密码" type="password" >
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
          </a-input-password>
        </a-form-item>
        <a-form-item>
          <a-row :gutter="8">
            <a-col :span="14">
              <a-input size="large" v-decorator="[ 'captcha', { rules: [{ required: true, message: '验证码不能为空' }] }, ]" @pressEnter="loginIn" placeholder="验证码" >
                <a-icon slot="prefix" type="safety" style="color: rgba(0,0,0,.25)" />
              </a-input>
            </a-col>
            <a-col :span="10">
              <img class="captcha-img" :src="captchaUrl" @click="getCaptcha" />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item class="button-bar">
          <a-space direction="vertical" style="width:100%" >
            <a-button size="large" block type="primary" @click="loginIn" v-track.login="{userInfo}" class="login-form-button">登录</a-button>
            <a-button size="large" block type="link" ghost><a :href="url">使用OA账户登录</a></a-button>
          </a-space>
        </a-form-item>
      </a-form>
    </div>
    <!-- <div class="footBox"><button @click="loginIn">登录</button></div> -->
  </div>
 </div>
</template>
<script>
  import bg1 from '../../assets/login/01.jpg'
  // import bg2 from '../../assets/login/02.jpg'
  // import bg3 from '../../assets/login/03.jpg'
  // import bg4 from '../../assets/login/04.jpg'
  // import bg5 from '../../assets/login/05.jpg'
  // import bg6 from '../../assets/login/06.jpg'

import {instance} from '../../Utils/axios'
import {baseUrl} from '@/Utils/url.js'
// import loginLogo from '@/assets/images/login-logo.png'
  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 8 },
  };
  const formTailLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 8, offset: 4 },
  };

export default {
  name: 'login',
  data(){
    return {
      userInfo: {},
      images:[bg1],
      checkNick: false,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      loginLogo: require('@/assets/images/login-logo.png'),
      formData: {},
      url: '',
      captchaUrl: '',
      captchaKey: '',
      banner:[
        {
          img:require('@/assets/login/01.jpg'),
          title:''
        }
      ]
    }
  },
  created(){
    let time = localStorage.getItem('loginTime')
    let refreshToken = localStorage.getItem('refreshToken')
    if(time && refreshToken){
      if((new Date().getTime() - time) < 18000 * 1000){
        this.$router.push('/factory?name=选择工厂')
      }
    }
    let src = window.location.href;
    if(src.split('/#/').length){
      let clientUrl = encodeURIComponent(src.split('/#/')[0] + '/#/checkLogin')
      let localUrl = instance.defaults.baseURL ? instance.defaults.baseURL : baseUrl
      this.url = `${localUrl}iot-auth/oauth/render/newhope?clientUrl=${clientUrl}`
    }
  },
  mounted(){
    this.form.setFieldsValue({
      account:'',
      password:'',
      captcha:''
    })
    this.getCaptcha()
  },
  computed:{
    loginStyle () {
      return { backgroundImage: `url(${this.images[Math.floor(Math.random() * this.images.length)]})` }
    }
  },
  methods:{
    setUserInfo(data){
      let { userId,userName,email, code: userNo, userType, phoneNumber, clientId, } = data || {}
      this.userInfo = {
        userName,
        userId,
        email,
        userNo,
        userType,
        phoneNumber,
        clientId,
      }
    },
    getCaptcha(){
      this.$http.get('/iot-auth/captcha').then(t => {
        if(t.success){
          this.captchaUrl = t.data.image
          this.captchaKey = t.data.key
        }
      })
    },
    loginIn(){
      window.localStorage.setItem('accessToken','');
      window.localStorage.setItem('loginTime',0)
      this.form.validateFields((err, params) => {
        const formData = new URLSearchParams()
        formData.append('account', params.account)
        formData.append('grantType', 'password')
        formData.append('password', params.password)
        formData.append('captcha', params.captcha)
        formData.append('captchaKey', this.captchaKey)
        formData.append('refreshToken', '')
        formData.append('tenantId', '000000')
        this.$http.post('/iot-auth/tokenWithCaptcha', formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(res => {
          let {success,msg} = res;
          if(success){
            let { accessToken,refreshToken,userId,userName,email, code: userNo, userType, phoneNumber, clientId, } = res.data || {}
            this.userInfo = {
              userName,
              userId,
              email,
              userNo,
              userType,
              phoneNumber,
              clientId,
            }
            window.localStorage.setItem('userInfo',JSON.stringify(res.data))
            window.localStorage.setItem('accessToken',accessToken);
            window.localStorage.setItem('userName',userName);
            window.localStorage.setItem('staffId',userId);
            window.localStorage.setItem('loginTime',new Date().getTime())
            window.localStorage.setItem('refreshToken',refreshToken)
            window.localStorage.removeItem('blenCurrent')
            window.localStorage.removeItem('blenSize')
            window.localStorage.removeItem('compoundCurrent')
            window.localStorage.removeItem('compoundSize')
            let targetUrl = window.localStorage.getItem('targetUrl')
            if(targetUrl && targetUrl !== '/login' && targetUrl !== '/checkLogin'){
              let factoryId = window.localStorage.getItem('factoryId')
              let factoryName = window.localStorage.getItem('factoryName')
              let factory = window.localStorage.getItem('factory')
              if(factoryId&&factoryName&&factory){
                this.$router.push(targetUrl)
              }else{
                this.$router.push('/factory?name=工厂选择')
              }
            }else{
              this.$router.push('/factory?name=工厂选择')
            }
          }else{
            msg && this.$message.error(msg)
          }
        });
      })
    },
    // loginIn() {
    //   this.form.validateFields(err => {
    //     if (!err) {
    //       console.info('success');
    //     }
    //   });
    // },
    // handleChange(e) {
    //   this.checkNick = e.target.checked;
    //   this.$nextTick(() => {
    //     this.form.validateFields(['nickname'], { force: true });
    //   });
    // },
  }
}
</script>
<style lang="scss" scoped>
.login-slider ::v-deep .slick-slide {
  text-align: center;
  height: 600px;
  line-height: 600px;
  overflow: hidden;
}

.login-slider ::v-deep .slick-slide h3 {
  color: #fff;
}

.banner{
  &-img{
    width:100%;
    height: 630px;
    background-size: cover;
    background-position: center center;
    background-size: cover;
  }
  &-title{
    position: absolute;
    left:0;right:0;
    bottom: 0;
    z-index: 10;
  }
}
.login-slider{
  height: 100%;
  height: 100%;
  width:500px;
  &-inner{
    width: 100%;
    height: 100%;
  }
}

.login-container{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width:500px;
  padding:0 70px;
}
.loginBox{
  display: flex;
  background: #fff;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 20px 40px rgba($color: #000000, $alpha: .1);
  overflow: hidden;
  border-radius: 10px;
  margin-top:-80px;
  .imgClass {
    // 中文图标
    height: 34px;
    margin-bottom: 25px;
    // 英文图标
    // width: 140px;
    // margin-bottom:40px;
  }
  .titleBox {
    text-align: center;
    margin-bottom:25px;
   
    .loginTitle{
      font-weight: bold;
      font-size: 14px;
      color: #1998f7;
    }
  }
}
.loginPageClass{
    height: 100vh;
    background-color: #f1f2f6;
    background-size: 1250px;
    background-repeat:repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    margin:0 auto;
    width:100%;
}
@keyframes sliderUp{
  from{
    transform: translateY(50%);
  }
  to{
    transform: translateY(0);
  }
}


</style>
<style lang="scss">
.loginBox .login-form{
  width: 100%;
}
.loginBox .ant-input-lg{
  font-size: 14px !important;
  height: 40px !important;
}
.button-bar{
  button{
    font-size: 14px !important;
    height: 40px;
    a{
      color: #1890ff !important;
    }
  }
}
.captcha-img{
  width: 100%;
  height: 40px;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

</style>